import { parseDataKey } from "./dateKeys";


export function getValForKey(obj, key) {
  if (!obj) return 0;

  // 1) direct hit (DD-MM-YYYY)
  if (obj[key] != null) {
    const v = obj[key];
    return extractNumber(v);
  }

  const parsed = parseDataKey(key);
  if (!parsed) return 0;

  // 2) YYYY-MM-DD
  const alt = parsed.format("YYYY-MM-DD");
  if (obj[alt] != null) {
    const v = obj[alt];
    return extractNumber(v);
  }

  // 3) slow fallback (Vue-style day match)
  for (const [k, v] of Object.entries(obj)) {
    const pk = parseDataKey(k);
    if (pk && pk.isSame(parsed, "day")) {
      return extractNumber(v);
    }
  }

  return 0;
}

/**
 * Vue-compatible extraction:
 * Vue mostly used: count / value
 * but NEVER floored here.
 */
function extractNumber(v) {
  if (v == null) return 0;

  if (typeof v === "number") return v;
  if (typeof v === "string") return Number(v);

  if (typeof v === "object") {
    if (v.count != null) return Number(v.count);
    if (v.value != null) return Number(v.value);
    if (v.unique != null) return Number(v.unique);
    if (v.tv != null) return Number(v.tv);
  }

  return Number(v) || 0;
}
